<script>
  // The upload panel on the Ready page.
  //
  // This is a REAL form post -- action="/file/upload",
  // enctype="multipart/form-data" -- not a fetch. The server creates the job
  // row, writes files/<id>/, and answers with a redirect to "/", so the browser
  // navigates and the list reloads itself.
  //
  // Two things changed beyond the styling:
  //
  //   * The Excel file is optional, which is what the server has always
  //     enforced -- routes/file.js rejects an upload with no pythonFile and
  //     accepts one with no excelFile. checkFiles() required BOTH before it
  //     would enable the button, so a Python-only job could not be submitted
  //     through the UI at all.
  //   * Validation is derived rather than imperative. checkFiles() only ever
  //     set `submit_btn.disabled = false`; it had no path back to true, so
  //     clearing a file selection left the button enabled.
  import { toast } from "../lib/toast.js";

  let pythonFile;
  let excelFile;
  let submitting = false;

  $: selectedPython = pythonFile && pythonFile.length ? pythonFile[0] : null;
  $: selectedExcel = excelFile && excelFile.length ? excelFile[0] : null;

  $: wrongPythonType =
    !!selectedPython &&
    selectedPython.name.split(".").pop().toLowerCase() !== "py";
  $: wrongExcelType =
    !!selectedExcel &&
    selectedExcel.name.split(".").pop().toLowerCase() !== "xlsx";

  $: canUpload =
    !!selectedPython && !wrongPythonType && !wrongExcelType && !submitting;

  function onSubmit() {
    submitting = true;
    toast("Uploading job…", { tone: "pending" });
  }
</script>

<form
  method="post"
  enctype="multipart/form-data"
  action="/file/upload"
  on:submit={onSubmit}
>
  <div class="surface p-4">
    <div>
      <h2 class="font-semibold">Upload a job</h2>
      <p class="mt-0.5 text-xs opacity-60">
        The Python script is run with the job id as its only argument.
      </p>
    </div>

    <div class="mt-3 grid gap-3 sm:grid-cols-2">
      <label class="block">
        <span class="mb-1 block text-xs opacity-60">Python file</span>
        <input
          type="file"
          class="file-input file-input-bordered file-input-sm w-full"
          accept=".py"
          name="pythonFile"
          bind:files={pythonFile}
        />
      </label>

      <label class="block">
        <span class="mb-1 block text-xs opacity-60">
          Excel file <span class="opacity-70">(optional)</span>
        </span>
        <input
          type="file"
          class="file-input file-input-bordered file-input-sm w-full"
          accept=".xlsx"
          name="excelFile"
          bind:files={excelFile}
        />
      </label>
    </div>

    {#if wrongPythonType || wrongExcelType}
      <p class="mt-2 flex items-center gap-2 text-sm text-error">
        <i class="fas fa-exclamation-circle text-xs" aria-hidden="true"></i>
        {wrongPythonType
          ? `${selectedPython.name} is not a .py file.`
          : `${selectedExcel.name} is not an .xlsx workbook.`}
      </p>
    {/if}

    <div class="mt-3 flex justify-end">
      <button
        type="submit"
        class="btn btn-primary btn-sm gap-2 normal-case"
        disabled={!canUpload}
      >
        <i
          class="fas {submitting
            ? 'fa-spinner fa-spin'
            : 'fa-file-upload'} text-xs"
          aria-hidden="true"
        ></i>
        {submitting ? "Uploading…" : "Upload"}
      </button>
    </div>
  </div>
</form>
